import React, { useEffect, useState } from 'react';
import './TeamTemplate.css';
import { useDispatch, useSelector } from 'react-redux';
import {
    Avatar,
    Card,
    DatePicker,
    Space,
    Button,
    Spin,
    Flex,
    Row,
    Col,
} from 'antd';
import { BsFillBookmarkCheckFill } from 'react-icons/bs';
import './TeamTemplate.css';
import GroupAvatar from '../../../Components/GroupAvatar/GroupAvatar';
import { IoIosInformationCircle } from 'react-icons/io';
import { MdOutlineArrowBackIos } from 'react-icons/md';
import { MdArrowForwardIos } from 'react-icons/md';
import { Dashboard_Public_Quick_Actions_ActionHandler } from '../../../Redux/Actions/user/DashboardPublicQuickActions';
import { Dashboard_Team_Members_ActionHandler } from '../../../Redux/Actions/user/DashboardTeamMembers';
import { Dashboard_Team_Activity_ActionHandler } from '../../../Redux/Actions/user/DashboardTeamActivity';
import CopySave from '../../Build/View/Folder/CopySave/CopySave';

const boldMember = '/assets/bold-people.svg';
const BookMark = '/assets/bookmark.svg';
const CurveImgRed = '/assets/curveimgred.svg';
const yourteam = '/assets/yourteam.svg';
const Linear_equalRed = '/assets/linearEqualred.svg';
const dateFormat = 'DD MMM YYYY';

const TeamTemplate = () => {
    let dispatch = useDispatch();
    const [isStandardOpen, setIsStandardOpen] = useState(false);
    const [selectedCopyItem, setSelectedCopyItem] = useState({});
    const [spinningPrebuilt, setSpinningPrebuilt] = useState(false);
    const [spinningTeamActivity, setspinningTeamActivity] = useState(false);
    const dashboardpublicquickactionsdata = useSelector(
        (state) =>
            state?.Dashboard_Public_Quick_Actions_Data
                ?.dashboard_public_quick_actions_data
    );
    const dashboardteammembersdata = useSelector(
        (state) =>
            state?.Dashboard_Team_Members_Data?.dashboard_team_members_data
    );
    const dashboardteamactivitysdata = useSelector(
        (state) =>
            state?.Dashboard_Team_Activity_Data?.dashboard_team_activity_data
                ?.data
    );

    const userSlugData = useSelector(
        (state) => state.SettingsUserProfileData.slug
    );

    useEffect(() => {
        dispatch(Dashboard_Public_Quick_Actions_ActionHandler());
        dispatch(Dashboard_Team_Members_ActionHandler());
        dispatch(Dashboard_Team_Activity_ActionHandler(''));
    }, []);

    useEffect(() => {
        if (dashboardpublicquickactionsdata) {
            setTimeout(() => {
                setSpinningPrebuilt(false);
            }, 1000);
        }
    }, [dashboardpublicquickactionsdata]);

    useEffect(() => {
        if (dashboardteamactivitysdata) {
            setTimeout(() => {
                setspinningTeamActivity(false);
            }, 1000);
        }
    }, [dashboardteamactivitysdata]);

    const StandardOverlay = (item) => {
        setSelectedCopyItem(item);
        setIsStandardOpen(!isStandardOpen);
    };

    const paginationButton = (page_data) => {
        setSpinningPrebuilt(true);
        dispatch(Dashboard_Public_Quick_Actions_ActionHandler(page_data));
    };

    const loadmoreButton = (page_data) => {
        setspinningTeamActivity(true);
        dispatch(Dashboard_Team_Activity_ActionHandler(page_data));
    };

    const ActiveDatePickerhandle = (value) => {
        if (value) {
            const date = new Date(value.$d);
            const options = {
                month: '2-digit',
                day: '2-digit',
                year: 'numeric',
            };
            const formattedDate = date.toLocaleDateString('en-US', options);
            dispatch(Dashboard_Team_Activity_ActionHandler('', formattedDate));
        } else {
            dispatch(Dashboard_Team_Activity_ActionHandler(''));
        }
    };

    const userDetails = JSON.parse(localStorage.getItem('userDetails'));

    const getMaxCount = (screenWidth) => {
        if (screenWidth >= 1200) {
            return 8;
        } else if (screenWidth >= 1024) {
            return 6;
        } else if (screenWidth >= 768) {
            return 5;
        } else {
            return 2;
        }
    };

    return (
        <div className='team-template'>
            <div className='pre-build-template'>
                <div className='try-template'>
                    <div>
                        <h4>
                            <BsFillBookmarkCheckFill />
                            Pre-built templates to try!
                        </h4>
                        <h4>
                            <Button
                                icon={<MdOutlineArrowBackIos />}
                                onClick={() =>
                                    paginationButton(
                                        dashboardpublicquickactionsdata?.current_page -
                                            1
                                    )
                                }
                                disabled={
                                    dashboardpublicquickactionsdata?.current_page -
                                        1 ===
                                    0
                                }
                            />
                            <Button
                                icon={<MdArrowForwardIos />}
                                onClick={() =>
                                    paginationButton(
                                        dashboardpublicquickactionsdata?.current_page +
                                            1
                                    )
                                }
                                disabled={
                                    dashboardpublicquickactionsdata?.current_page ===
                                    dashboardpublicquickactionsdata?.last_page
                                }
                            />
                        </h4>
                    </div>
                    {dashboardpublicquickactionsdata?.data?.length > 0 ? (
                        <Card
                            bordered={false}
                            className='curve_card curve-card-team custom-scrollbar-curve'
                            style={{ height: 'auto' }}>
                            <Spin spinning={spinningPrebuilt} size='large'>
                                <Row>
                                    <div className='home-grid-container'>
                                        {dashboardpublicquickactionsdata?.data &&
                                            dashboardpublicquickactionsdata?.data.map(
                                                (item, index) => (
                                                    <Col span={24}>
                                                        <div
                                                            key={`grid-home-${index}`}
                                                            style={{
                                                                position:
                                                                    'relative',
                                                            }}>
                                                            <img
                                                                src={
                                                                    CurveImgRed
                                                                }
                                                                alt=''
                                                                className='curve-image'
                                                            />
                                                            <img
                                                                src={
                                                                    Linear_equalRed
                                                                }
                                                                alt=''
                                                                className='curve-linerequal-img pre'
                                                            />
                                                            <IoIosInformationCircle className='curve-team-icon' />
                                                            <p className='curve-para1'>
                                                                {item.name}
                                                            </p>
                                                            {userSlugData?.includes(
                                                                'copy-qa-from-library'
                                                            ) && (
                                                                <>
                                                                    {' '}
                                                                    <p
                                                                        className='curve-para2 copy'
                                                                        onClick={() =>
                                                                            StandardOverlay(
                                                                                item
                                                                            )
                                                                        }>
                                                                        Copy and
                                                                        Use
                                                                    </p>
                                                                    <hr className='hr-tag-red' />{' '}
                                                                </>
                                                            )}
                                                        </div>
                                                    </Col>
                                                )
                                            )}
                                    </div>
                                </Row>
                            </Spin>
                        </Card>
                    ) : (
                        <Card
                            bordered={false}
                            className='curve_card m-auto curve-card-team custom-scrollbar-curve'>
                            <img src={BookMark} alt='' />
                            <h1>No Pre-built templates found...</h1>
                        </Card>
                    )}
                </div>
                <div className='your-team'>
                    <Flex>
                        <img src={yourteam} alt='' />
                        <h4>Your team</h4>
                    </Flex>
                    <Card style={{ width: '100%' }}>
                        <div className='your-team-flex'>
                            <p>
                                <span> All Team Members: </span>
                                <span className='tomato-color-team'>
                                    {dashboardteammembersdata?.length || 0}
                                </span>
                            </p>
                            <p className='tomato-color-team'>View All</p>
                        </div>
                        <div>
                            <div>
                                {userDetails?.profile_picture !== '' ? (
                                    <Avatar
                                        className='your-avtar'
                                        size={{
                                            xs: 24,
                                            sm: 32,
                                            md: 40,
                                            lg: 55,
                                            xl: 55,
                                            xxl: 55,
                                        }}
                                        src={userDetails?.profile_picture}
                                    />
                                ) : null}
                                <p>You</p>
                            </div>
                            <div>
                                <GroupAvatar
                                    getMaxCount={getMaxCount}
                                    size={{
                                        xs: 24,
                                        sm: 32,
                                        md: 40,
                                        lg: 55,
                                        xl: 55,
                                        xxl: 55,
                                    }}
                                    otherMember={false}
                                    data={dashboardteammembersdata}
                                    isResponsiveCount={true}
                                />
                                <p>Other Team Members</p>
                            </div>
                        </div>
                    </Card>
                </div>
            </div>
            <div className='team-activity'>
                <div>
                    <h4>
                        <img src={boldMember} alt='' />
                        Team Activity
                    </h4>
                    <h4>
                        <Button
                            icon={<MdOutlineArrowBackIos />}
                            onClick={() =>
                                loadmoreButton(
                                    dashboardteamactivitysdata?.current_page - 1
                                )
                            }
                            disabled={
                                dashboardteamactivitysdata?.current_page - 1 ===
                                0
                            }
                        />
                        <Button
                            icon={<MdArrowForwardIos />}
                            onClick={() =>
                                loadmoreButton(
                                    dashboardteamactivitysdata?.current_page + 1
                                )
                            }
                            disabled={
                                dashboardteamactivitysdata?.current_page ===
                                dashboardteamactivitysdata?.last_page
                            }
                        />
                    </h4>
                </div>
                <Card bordered={false}>
                    <div className='team-date-picker'>
                        <p>
                            <span> Total Activity's: </span>
                            <span className='tomato-color-team'>
                                <b>{dashboardteamactivitysdata?.total || 0}</b>
                            </span>
                        </p>
                        <Space direction='vertical'>
                            <DatePicker
                                format={dateFormat}
                                onChange={ActiveDatePickerhandle}
                            />
                        </Space>
                    </div>
                    <Spin spinning={spinningTeamActivity} size='large'>
                        <div>
                            {dashboardteamactivitysdata?.data.map(
                                (item, index) => (
                                    <>
                                        <div
                                            className='teamActivity-line_separator'
                                            key={`separator-${index}`}></div>
                                        <div
                                            key={index}
                                            className='teamActivity-img'>
                                            <img
                                                src={item?.profile_picture}
                                                alt={item.first_name}
                                                className='team-activity-img'
                                            />
                                            <p>
                                                <b>
                                                    {item.first_name}{' '}
                                                    {item.last_name}
                                                </b>{' '}
                                                {item.is_run === 1
                                                    ? 'Ran'
                                                    : null}{' '}
                                                {item.is_created === 1
                                                    ? 'Created'
                                                    : null}{' '}
                                                <b>{item.quick_action}</b>
                                            </p>
                                        </div>
                                    </>
                                )
                            )}
                        </div>
                    </Spin>
                </Card>
            </div>
            {isStandardOpen ? (
                <CopySave
                    StandardOverlay={StandardOverlay}
                    isStandardOpen={isStandardOpen}
                    selectedCopyItem={selectedCopyItem}
                    homepageflag={true}
                />
            ) : null}
        </div>
    );
};
export default TeamTemplate;
